import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  units: [],
  error: null,
  message: '',
};
const unitReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_UNIT_MASTER_REQUEST:
    case actionTypes.GET_UNITS_REQUEST:
    case actionTypes.SINGLEADD_UNIT_REQUEST:
    case actionTypes.UPDATE_UNIT_REQUEST:
    case actionTypes.DELETE_UNIT_REQUEST:
    case actionTypes.MULTIDELETE_CLIENTUNITS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPLOAD_UNIT_MASTER_SUCCESS:
    case actionTypes.DELETE_UNIT_SUCCESS:
    case actionTypes.MULTIDELETE_CLIENTUNITS_SUCCESS:
    case actionTypes.SINGLEADD_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case actionTypes.GET_UNITS_SUCCESS:
      return {
        ...state,
        loading: false,
        units: action.payload,
      };

    case actionTypes.UPLOAD_UNIT_MASTER_FAILURE:
    case actionTypes.GET_UNITS_FAILURE:
    case actionTypes.UPDATE_UNIT_FAILURE:
    case actionTypes.DELETE_UNIT_FAILURE:
    case actionTypes.MULTIDELETE_CLIENTUNITS_FAILURE:
    case actionTypes.SINGLEADD_UNIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default unitReducer
